<!-- components/Loading.vue -->
<template>
  <div>
    <div v-if="isLoadingStart" class="loading-overlay loading-overlay-start">
        <img src="../assets/imgs/shapes/loading_wayi.gif" style="width: 1186px;height: 668px;" alt="">
    </div>
    <div v-if="isLoadingEnd" class="loading-overlay loading-overlay-end"> <img src="../assets/imgs/shapes/loading_wayi.gif" style="width: 1186px;height: 668px;" alt=""></div>
  </div>
  </template>
  
  <script>
  export default {
    props: {},
    data(){
      return{
        isLoadingStart:false,
        isLoadingEnd:false
      }
    },
    computed:{
      isLoading(){
        return this.$store.state.app.pageLoading
      }
    },
    watch:{
      isLoading(status){
        console.log(status , '状态比纳湖')
        if(status){
          this.isLoadingStart = true
        }else{
          this.isLoadingStart = false
          this.isLoadingEnd = true
          let timer = setTimeout(()=>{
            this.isLoadingEnd = false
            clearTimeout(timer)
          },1000)
        }
      }
    }
  };
  </script>
  
  <style>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000;
    color: #fff;
    font-size: 2em;
    z-index: 9999;
    
  }
  .loading-overlay-start{
    opacity: 0;
    animation: fadeIn 1s infinite;
  }
  .loading-overlay-end{
    opacity: 1;
    animation: fadeOut 1s infinite;
  }
  @keyframes fadeIn {
    0% {
    opacity: 0; 
  }
  20% {
    opacity: 0.5; 
  }
  40%{
    opacity: 1;
  }
  80% {
    opacity: 1; 
  }
  100% {
    opacity: 1; 
  }
}
@keyframes fadeOut {
    0% {
    opacity: 1; 
  }
  20% {
    opacity: 1; 
  }
  40%{
    opacity: 1;
  }
  80% {
    opacity: 0.5; 
  }
  100% {
    opacity: 0; 
  }
}
  </style>
  